import { TrendingUp, BookOpen, ClipboardList, Library, Users, ShieldCheck, Repeat, CalendarDays } from 'lucide-react'
import './Accesos.css'

const ITEMS_BASE = [
  { tab: 'progreso', icon: TrendingUp, label: 'Progreso' },
  { tab: 'clases', icon: BookOpen, label: 'Clases' },
  { tab: 'plan', icon: ClipboardList, label: 'Plan' },
  { tab: 'habitos', icon: Repeat, label: 'Hábitos' },
  { tab: 'turnos', icon: CalendarDays, label: 'Turnos' }
]

export default function Accesos({ esSuperAdmin, workspaceActivo, onNavegar }) {
  const esOwner = workspaceActivo?.rolEnWorkspace === 'owner'

  const pins = []
  if (esSuperAdmin) pins.push({ tab: 'super-admin', icon: ShieldCheck, label: 'Panel super-admin' })
  if (esOwner || esSuperAdmin) pins.push({ tab: 'admin-workspace', icon: Users, label: `Admin de ${workspaceActivo.nombre}` })

  // El filtrado por producto es orden visual, no control de acceso (ni RLS
  // ni datos se restringen acá) — solo aplica al paciente. Si no hay
  // modulosConfig todavía (owner/super-admin, o paciente sin producto
  // asignado), se muestran todos los tiles (fail-open a propósito).
  const modulosConfig = workspaceActivo?.modulosConfig
  const itemsPaciente = modulosConfig
    ? ITEMS_BASE.filter(item => modulosConfig[item.tab] !== false)
    : ITEMS_BASE

  const items = esSuperAdmin
    ? [...ITEMS_BASE, { tab: 'admin', icon: Library, label: 'Recetarios' }]
    : esOwner
      ? ITEMS_BASE
      : itemsPaciente

  return (
    <div className="accesos-page">
      <div className="page-header">
        <h1 className="page-titulo">Menú</h1>
        <p className="page-subtitulo">Todo lo demás, en un solo lugar</p>
      </div>

      {pins.length > 0 && (
        <div className="accesos-pins">
          {pins.map(item => (
            <button key={item.tab} className="accesos-pin" onClick={() => onNavegar(item.tab)}>
              <item.icon className="accesos-pin-icon" size={22} strokeWidth={2} />
              <span className="accesos-pin-label">{item.label}</span>
            </button>
          ))}
        </div>
      )}

      <div className="accesos-grid">
        {items.map(item => (
          <button key={item.tab} className="accesos-item" onClick={() => onNavegar(item.tab)}>
            <item.icon className="accesos-item-icon" size={28} strokeWidth={2} />
            <span className="accesos-item-label">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
